import '@sparta.global.utilities/sparta-input-utility/dist/es6.js';
import $ from '@sparta.global.vendors/jquery';
import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import spartaStoreUtility from '@sparta.global.utilities/sparta-store-utility/dist/es6.js';
import SpartaUILayersUtility from '@sparta.global.utilities/sparta-ui-layers-utility/dist/es6.js';
import Handlebars from '@sparta.global.vendors/handlebars';
import { compare } from '@sparta.global.helpers/comparisons-helper/dist/es6.js';
import { json } from '@sparta.global.helpers/json-helper/dist/es6.js';

const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <div class=\"row\">\r\n    <div class=\"column\">\r\n      <div\r\n        class=\"\r\n          state-selector-container\r\n          "
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"inputStyle") : stack1),"==","small",{"name":"compare","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":10},"end":{"line":8,"column":77}}})) != null ? stack1 : "")
    + "\r\n          "
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"inputStyle") : stack1),"==","large",{"name":"compare","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":9,"column":10},"end":{"line":9,"column":77}}})) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"skin") : stack1),"==","primary",{"name":"compare","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":10,"column":10},"end":{"line":12,"column":22}}})) != null ? stack1 : "")
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"skin") : stack1),"==","secondary",{"name":"compare","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":13,"column":10},"end":{"line":15,"column":22}}})) != null ? stack1 : "")
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"skin") : stack1),"==","outline",{"name":"compare","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":16,"column":10},"end":{"line":18,"column":22}}})) != null ? stack1 : "")
    + "          "
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"skin") : stack1),"==","default",{"name":"compare","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":19,"column":10},"end":{"line":19,"column":68}}})) != null ? stack1 : "")
    + "\r\n        \"\r\n      >\r\n        <form id=\"stateSelectSideWellForm\" name=\"stateSelectSideWellForm\" autocomplete=\"off\">\r\n          <div class=\"spa-input spa-input-box\">\r\n            <label class=\"spa-input-label\" for=\"stateSelect\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"infoFor") : stack1), depth0)) != null ? stack1 : "")
    + "</label>\r\n            <div class=\"wrap\">\r\n              <select class=\"spa-input-select state-select\" id=\"stateSelect\">\r\n                <option value=\"\">"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"selectState") : stack1), depth0))
    + "</option>\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"states") : stack1),{"name":"each","hash":{},"fn":container.program(14, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":28,"column":16},"end":{"line":30,"column":25}}})) != null ? stack1 : "")
    + "              </select>\r\n              <button\r\n                id=\"stateSelectorSubmit\"\r\n                class=\"spa-state-select-link spa-btn spa-btn--medium spa-btn--primary\"\r\n              >\r\n                "
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"submit") : stack1), depth0))
    + "<span class=\"ada-hidden\"> "
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"submitAda") : stack1), depth0))
    + "</span>\r\n              </button>\r\n            </div>\r\n          </div>\r\n        </form>\r\n      </div>\r\n    </div>\r\n  </div>\r\n";
},"2":function(container,depth0,helpers,partials,data) {
    return "input--small";
},"4":function(container,depth0,helpers,partials,data) {
    return "input--large";
},"6":function(container,depth0,helpers,partials,data) {
    return "            spa-right-rail-module spa-right-rail-module--primary\r\n";
},"8":function(container,depth0,helpers,partials,data) {
    return "            spa-right-rail-module spa-right-rail-module--secondary\r\n";
},"10":function(container,depth0,helpers,partials,data) {
    return "            spa-right-rail-module spa-right-rail-module--outline\r\n";
},"12":function(container,depth0,helpers,partials,data) {
    return "default";
},"14":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                  <option value=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"abbreviation") || (depth0 != null ? lookupProperty(depth0,"abbreviation") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"abbreviation","hash":{},"data":data,"loc":{"start":{"line":29,"column":33},"end":{"line":29,"column":49}}}) : helper)))
    + "\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":29,"column":51},"end":{"line":29,"column":61}}}) : helper))) != null ? stack1 : "")
    + "</option>\r\n";
},"16":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <div\r\n    id=\"stateModalContent\"\r\n    class=\"\r\n      hide state-selector-container\r\n      "
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"inputStyle") : stack1),"==","small",{"name":"compare","hash":{},"fn":container.program(17, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":52,"column":6},"end":{"line":52,"column":75}}})) != null ? stack1 : "")
    + "\r\n      "
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"inputStyle") : stack1),"==","large",{"name":"compare","hash":{},"fn":container.program(19, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":53,"column":6},"end":{"line":53,"column":75}}})) != null ? stack1 : "")
    + "\r\n    \"\r\n    data-options='{\r\n      \"closeAdaTextOverride\": \""
    + ((stack1 = container.lambda(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"layerContent") : stack1)) != null ? lookupProperty(stack1,"stateModalContent") : stack1)) != null ? lookupProperty(stack1,"title") : stack1), depth0)) != null ? stack1 : "")
    + "\",\r\n      \"noCloseFocusAuto\": false,\r\n      \"type\":\"modal\",\r\n      \"closeOnEscape\": false\r\n      "
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"modalCloseButton") : stack1),"==","false",{"name":"compare","hash":{},"fn":container.program(21, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":60,"column":6},"end":{"line":62,"column":18}}})) != null ? stack1 : "")
    + "    }'\r\n  >\r\n    <h3 id=\"stateModalContent_title\" class=\"title\">\r\n      "
    + ((stack1 = container.lambda(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"layerContent") : stack1)) != null ? lookupProperty(stack1,"stateModalContent") : stack1)) != null ? lookupProperty(stack1,"title") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n    </h3>\r\n    <div class=\"content\">\r\n      <div class=\"intro\">"
    + ((stack1 = container.lambda(((stack1 = ((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"layerContent") : stack1)) != null ? lookupProperty(stack1,"stateModalContent") : stack1)) != null ? lookupProperty(stack1,"content") : stack1)) != null ? lookupProperty(stack1,"text1") : stack1), depth0)) != null ? stack1 : "")
    + "</div>\r\n      <form id=\"stateSelectModalForm\" name=\"stateSelectModalForm\" autocomplete=\"off\">\r\n        <div class=\"spa-input spa-input-box\">\r\n          <label class=\"spa-input-label ada-hidden\" for=\"stateSelectModal\">\r\n            "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"adaLabel") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n          </label>\r\n          <div class=\"wrap\">\r\n            <select class=\"spa-input-select state-select\" id=\"stateSelectModal\">\r\n              <option value=\"\">"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"selectState") : stack1), depth0))
    + "</option>\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"states") : stack1),{"name":"each","hash":{},"fn":container.program(23, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":78,"column":14},"end":{"line":80,"column":23}}})) != null ? stack1 : "")
    + "            </select>\r\n            <button\r\n              id=\"stateSelectorSubmit\"\r\n              class=\"spa-state-select-link spa-btn spa-btn--medium spa-btn--primary\"\r\n            >\r\n              "
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"submit") : stack1), depth0))
    + "<span class=\"ada-hidden\"> "
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"submitAda") : stack1), depth0))
    + "</span>\r\n            </button>\r\n          </div>\r\n        </div>\r\n      </form>\r\n      <div class=\"modal-state-space\">&nbsp;</div>\r\n    </div>\r\n  </div>\r\n";
},"17":function(container,depth0,helpers,partials,data) {
    return " input--small";
},"19":function(container,depth0,helpers,partials,data) {
    return " input--large";
},"21":function(container,depth0,helpers,partials,data) {
    return ",\r\n        \"closeButton\": false\r\n";
},"23":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                <option value=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"abbreviation") || (depth0 != null ? lookupProperty(depth0,"abbreviation") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"abbreviation","hash":{},"data":data,"loc":{"start":{"line":79,"column":31},"end":{"line":79,"column":47}}}) : helper)))
    + "\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"name") || (depth0 != null ? lookupProperty(depth0,"name") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data,"loc":{"start":{"line":79,"column":49},"end":{"line":79,"column":59}}}) : helper))) != null ? stack1 : "")
    + "</option>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"pageLocation") : stack1),"==","content-well",{"name":"compare","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":0},"end":{"line":44,"column":12}}})) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"modalOnLoad") : stack1),"==","true",{"name":"compare","hash":{},"fn":container.program(16, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":47,"column":0},"end":{"line":94,"column":12}}})) != null ? stack1 : "");
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.global.modules/state-selector-module",
  "version": "1.0.30",
  "id": "stateSelectorModule",
  "containerID": "globalStateSelectorModule",
  "moduleName": "global-state-selector-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "state-selector-module",
  "data": {
    "init": "StateSelectorModule",
    "options": {
      "pageLocation": "{{module.pageLocation}}",
      "modalOnLoad": "{{module.modalOnLoad}}",
      "modalOpenOnLoad": "{{module.modalOpenOnLoad}}",
      "modalData": "{{json modalData.changeState.actionType.options}}"
    }
  },
  "moduleParams": [{
    "name": "id",
    "type": "string",
    "description": ""
  }, {
    "name": "pageLocation",
    "type": "string",
    "values": ["content-well"],
    "default": "content-well",
    "description": "This parameter controls where the state selector will be displayed."
  }, {
    "name": "inputStyle",
    "type": "string",
    "values": ["small", "large"],
    "default": "small",
    "description": "This parameter controls the dropdown style.  Default: 'small'"
  }, {
    "name": "skin",
    "type": "string",
    "values": ["primary", "secondary", "outline", "default"],
    "default": "default",
    "description": "This parameter controls the module look and feel."
  }, {
    "name": "modalOnLoad",
    "type": "string",
    "values": ["true", "false"],
    "default": "false",
    "description": "This parameter controls if the modal layer is added to the page."
  }, {
    "name": "modalOpenOnLoad",
    "type": "string",
    "values": ["true", "false"],
    "default": "true",
    "description": "If modalOnLoad is true, this parameter controls if the state modal layer is opened when the page is first loaded.  false will allow page to open modal on click at a later time."
  }, {
    "name": "modalCloseButton",
    "type": "string",
    "values": ["true", "false"],
    "default": "false",
    "description": "Prevent the close button from state modal layer by default."
  }],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {
        compare,
        json
      },
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {
    compare,
    json
  },
  "dependencies": {
    "@sparta.global.helpers/button-helper": "^1.1.4",
    "@sparta.global.helpers/comparisons-helper": "^1.0.3",
    "@sparta.global.helpers/json-helper": "^1.0.2",
    "@sparta.global.utilities/sparta-input-utility": "^1.2.12",
    "@sparta.global.utilities/sparta-module-utility": "^1.1.8",
    "@sparta.global.utilities/sparta-store-utility": "^1.0.3",
    "@sparta.global.utilities/sparta-color-style-token-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-spacing-style-token-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-global-style-token-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-breakpoint-style-token-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-ui-layers-utility": "^1.1.16",
    "@sparta.global.vendors/handlebars": "^4.7.7",
    "@sparta.global.vendors/jquery": "^3.5.1"
  },
  "stores": []
};

/**
 * Handles the display of the State Selector.
 */
class StateSelectorModule extends Module {
  /**
   * Creates an instance of the module.
   * @param {object} options - The options this module was initialized with.
   * @param {object} context - Context for the module.
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
  }

  /**
   * Called when this module is bootstrapped by the client.
   * @returns {void}
   */
  init() {
    const $stateSelect = $('.state-selector-container select.state-select');
    const storedState = spartaStoreUtility._getState() ? spartaStoreUtility._getState() : null;
    let stateUrlParam = this.SpartaFunctions.getUrlParam('state') || '';
    stateUrlParam = stateUrlParam.toUpperCase();

    // get JCR options from module config
    const modalObj = this.settings.modalData;

    // if state cookie is set, set state dropdowns
    if (typeof storedState === 'string' && storedState.length === 2) {
      $stateSelect.val(storedState);
    } else if (this.settings.modalOpenOnLoad === true && stateUrlParam.length === 0) {
      // open modal if modalOnLoad && state cookie is not set
      // TODO - remove this setTimeout when spartaGlobal
      setTimeout(() => {
        // update strings from JCR values
        if (modalObj) {
          SpartaUILayersUtility.openLayer($('#stateModalContent'), null, {
            closeAdaText: modalObj.closeAdaText,
            closeAdaTextSpacer: modalObj.closeAdaTextSpacer,
            closeText: modalObj.closeText
          });
        } else {
          SpartaUILayersUtility.openLayer($('#stateModalContent'));
        }
        $('#stateSelectModal').focus();
      }, 0);
    } else if (typeof stateUrlParam === 'string' && stateUrlParam.length === 2 && $stateSelect.val().length === 0) {
      $stateSelect.val(stateUrlParam);
      spartaStoreUtility._setState(stateUrlParam);
    }
    this.Events.sub('userStateUpdated', newState => {
      if (typeof newState === 'string' && newState.length === 2) {
        $stateSelect.val(newState);
        spartaStoreUtility._setState(newState);
      }
    });
    const {
      settings
    } = this;
    $(document.body).on('click', '.spa-state-select-link', function bodyClick() {
      const $this = $(this);
      const $form = $this.closest('form');
      const state = $form.find('select.state-select').val();
      if (typeof state === 'string' && state.length === 2) {
        spartaStoreUtility._setState(state);
      }
      if (settings.redirectLocation) {
        window.location = settings.redirectLocation;
      } else {
        spartaStoreUtility.persist('userStateChanged', true, 'sessionStorage');
        window.location.reload();
      }
      return false;
    });
    this.addRoleButton();
  }

  /**
   * Adds a role of "button" to all `.spa-state-select-link` elements.
   * @returns {void}
   */
  addRoleButton() {
    const goButtons = document.getElementsByClassName('spa-state-select-link');
    for (let i = 0; i < goButtons.length; i++) {
      goButtons[i].setAttribute('role', 'button');
    }
  }
}
registerModuleClass({
  moduleClass: StateSelectorModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { StateSelectorModule as default, moduleConfig };
